// extracted by mini-css-extract-plugin
export default {"container":"DetailedCategory_container__RQP4c","item":"DetailedCategory_item__PnvU4","active":"DetailedCategory_active__ckYWv"};